export default __webpack_public_path__ + "static/media/cisco.990fda88.svg";